export default __webpack_public_path__ + "static/media/visual.d99cfbf9.jpg";